import { SiteUtilities } from './utils';

const restrictedDomains = {};

async function getRestrictedDomains () {
  try {
    const form = document.querySelector('.form-field');
    if (form) {
      const dateObject = new Date();
      const key = '?t=' + dateObject.getDate() + '' + dateObject.getMonth() + '' + dateObject.getFullYear() + '' + dateObject.getHours();
      const domains = await jQuery.getJSON('https://website-assets-fw.freshworks.com/restricted-domains.json' + key);
      Object.assign(restrictedDomains, domains);
    }
  } catch (err) {
    SiteUtilities.log(
      'Failed to load restricted domains from s3', 'error',
      'restricted-domains', 0, err
    );
  }
}

function init () {
  document.addEventListener('DOMContentLoaded', () => {
    getRestrictedDomains();
  });
}

export default { init, restrictedDomains };
